export const reviews = [
  {
    img: "./img/reviews-1.jpg",
    name: "Кирилл Девяткин",
    text: "Я даже не ожидал, что все сделают настолько быстро."
  },
  {
    img: "./img/reviews-2.jpg",
    name: "Матвей Семенов",
    text: "Молодцы! Окна очень понравились. Буду рекомендовать всем своим знакомым."
  },
  {
    img: "./img/reviews-3.jpg",
    name: "Иван Журавлев",
    text: "Все сделали быстро и качественно. Большое им спасибо!"
  },
  {
    img: "./img/reviews-2.jpg",
    name: "Денис Попов",
    text: "Долго выбирали и остановились на этой фирме. Жене очень понравилось, насколько качественно сделали окна"
  },

];